/** @jsxImportSource @emotion/react */
import { useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { useGetAppModalStyles } from "./index.styles";
import ScrollToTopButton from "../ScrollToTopButton";

const AppModal = ({
  open,
  onClose,
  maxWidth = "1100px",
  extraActions,
  showScrollTop = true,
  children,
}) => {
  const classes = useGetAppModalStyles();
  const contentRef = useRef(null);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{ sx: { ...classes.paper, maxWidth } }}
    >
      <div css={classes.accent} />
      <div css={classes.overlay}>
        {extraActions}
        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={classes.closeButton}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
      <DialogContent ref={contentRef} sx={classes.content}>
        {children}
      </DialogContent>
      {showScrollTop && (
        <ScrollToTopButton containerRef={contentRef} variant="absolute" />
      )}
    </Dialog>
  );
};

export default AppModal;
